export function useEventBus() {
	const bus = useState('eventBus', () => ({}));

	function emit(event, data = null) {
		bus.value = {
			event,
			data,
		};
	}

	// listen for any changes (event name and data) for specific event and call callback
	function subscribe(event, callback, options = {}) {
		watch(
			bus,
			newData => {
				if (newData.event == event) {
					return callback(newData.data);
				}
			},
			{deep: true, ...options}
		);
	}

	function clearEventBus() {
		bus.value = {};
	}

	return {
		emit,
		bus,
		subscribe,
		clearEventBus,
	};
}
